import { render, staticRenderFns } from "./TabelaFiscais.vue?vue&type=template&id=328ed4f0&"
import script from "./TabelaFiscais.vue?vue&type=script&lang=js&"
export * from "./TabelaFiscais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports